import Service from 'additiv-services/services/core/service';
import { getQueryStringByObject } from 'additiv-services/utils/queryUtils';
import { getCustomServiceLayerHeader } from 'additiv-services/setup';
import {
    CUSTOM_SERVICE_LAYER_SERVICES,
    getCustomServiceLayerBaseUrl,
} from '../constants';

class PlanService extends Service {
    static #baseServiceUrl = getCustomServiceLayerBaseUrl(
        CUSTOM_SERVICE_LAYER_SERVICES.PLAN,
    );

    static getKudiNote({ portfolioId, params }) {
        const queryString = getQueryStringByObject(params);

        return Service.getRequest(
            `${this.#baseServiceUrl}/${portfolioId}/kudiNote?${queryString}`,
            { isSecure: true, axiosSetup: { headers: getCustomServiceLayerHeader() } },
        );
    }

    static updatePbNumber({
        portfolioId, pbNumber, vstNumber, agentId,
    }) {
        return Service.patchRequest(
            `${this.#baseServiceUrl}/${portfolioId}/pb-number`,
            { pbNumber, vstNumber, agentId },
            { isSecure: true, axiosSetup: { headers: getCustomServiceLayerHeader() } },
        );
    }

    static getPlanDetails({ portfolioId }) {
        return Service.getRequest(
            `${this.#baseServiceUrl}/${portfolioId}/details`,
            { isSecure: true, axiosSetup: { headers: getCustomServiceLayerHeader() } },
        );
    }

    static updateGeneralAgency({ portfolioId, generalAgency }) {
        return Service.patchRequest(
            `${this.#baseServiceUrl}/${portfolioId}/generalAgency?agencyId=${generalAgency}`,
            null,
            { isSecure: true, axiosSetup: { headers: getCustomServiceLayerHeader() } },
        );
    }

    static getPbNumberChangeHistory({ portfolioId, pageNumber, pageSize }) {
        const queryString = getQueryStringByObject({ pageNumber, pageSize });

        return Service.getRequest(
            `${this.#baseServiceUrl}/${portfolioId}/pb-number-history?${queryString}`,
            { isSecure: true, axiosSetup: { headers: getCustomServiceLayerHeader() } },
        );
    }

    static updateIssueCommission({ portfolioId, issueCommission }) {
        return Service.patchRequest(
            `${this.#baseServiceUrl}/${portfolioId}/provisioning-percentage?issueComission=${issueCommission}`,
            null,
            { isSecure: true, axiosSetup: { headers: getCustomServiceLayerHeader() } },
        );
    }

    static getIssueCommissionChangeHistory({
        portfolioId,
        pageNumber,
        pageSize,
    }) {
        const queryString = getQueryStringByObject({ pageNumber, pageSize });

        return Service.getRequest(
            `${this.#baseServiceUrl}/${portfolioId}/provisioning-percentage?${queryString}`,
            { isSecure: true, axiosSetup: { headers: getCustomServiceLayerHeader() } },
        );
    }

    static getFeesChangeHistory({
        investmentApplicationId,
        feeType,
        pageNumber,
        pageSize,
    }) {
        const queryString = getQueryStringByObject({ pageNumber, pageSize });

        return Service.getRequest(
            `${this.#baseServiceUrl}/${investmentApplicationId}/feeChangeHistory/${feeType}?${queryString}`,
            { isSecure: true, axiosSetup: { headers: getCustomServiceLayerHeader() } },
        );
    }

    static getGeneralAgencyChangeHistory({
        portfolioId,
        pageNumber,
        pageSize,
    }) {
        const queryString = getQueryStringByObject({ pageNumber, pageSize });

        return Service.getRequest(
            `${this.#baseServiceUrl}/${portfolioId}/general-agency-history?${queryString}`,
            { isSecure: true, axiosSetup: { headers: getCustomServiceLayerHeader() } },
        );
    }

    static getAgentAndAgencyInfo({ portfolioId }) {
        return Service.getRequest(
            `${this.#baseServiceUrl}/agent-agency-information?portfolioId=${portfolioId}`,
            { isSecure: true, axiosSetup: { headers: getCustomServiceLayerHeader() } },
        );
    }

    static checkIfChangePlanInProgress({ portfolioId }) {
        return Service.getRequest(
            `${this.#baseServiceUrl}/${portfolioId}/changePlan`,
            { isSecure: true, axiosSetup: { headers: getCustomServiceLayerHeader() } },
        );
    }

    static getAssetManagement(payload) {
        const queryString = getQueryStringByObject(payload);

        return Service.getRequest(
            `${this.#baseServiceUrl}/asset-management-fee?${queryString}`,
            { isSecure: true, axiosSetup: { headers: getCustomServiceLayerHeader() } },
        );
    }

    static getPlanNamesByContactGroupId({ contactGroupId }) {
        return Service.getRequest(
            `${this.#baseServiceUrl}/${contactGroupId}/names`,
            { isSecure: true, axiosSetup: { headers: getCustomServiceLayerHeader() } },
        );
    }

    static getWithdrawalData({ portfolioId, language }) {
        return Service.getRequest(
            `${this.#baseServiceUrl}/${portfolioId}/withdrawal-data?language=${language}`,
            {
                isSecure: true,
                axiosSetup: { headers: getCustomServiceLayerHeader() },
            },
        );
    }

    static getPlanStatus({ planId }) {
        return Service.getRequest(
            `${this.#baseServiceUrl}/${planId}/status`,
            { isSecure: true, axiosSetup: { headers: getCustomServiceLayerHeader() } },
        );
    }
}

export default PlanService;
